// Components
import { Section } from '@tracklib/kit'

// Utils
import formatHtml from 'components/staticpages/formathtml'

import styles from './centeredtextblock.css'

type CenteredTextBlockProps = {
  value: {
    text: string
  }
}

const CenteredTextBlock = ({ value: { text } }: CenteredTextBlockProps) => (
  <Section size="small">
    <p dangerouslySetInnerHTML={{ __html: formatHtml(text) }} className={styles.text} />
  </Section>
)

export default CenteredTextBlock
